"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalProvider = exports.Event = void 0;
const eventManager_1 = __importDefault(require("./eventManager"));
var Event;
(function (Event) {
    Event[Event["Show"] = 0] = "Show";
    Event[Event["Hide"] = 1] = "Hide";
    Event[Event["Clear"] = 2] = "Clear";
    Event[Event["DidMount"] = 3] = "DidMount";
    Event[Event["WillUnmount"] = 4] = "WillUnmount";
    Event[Event["Change"] = 5] = "Change";
    Event[Event["ClearWaitingQueue"] = 6] = "ClearWaitingQueue";
})(Event = exports.Event || (exports.Event = {}));
var ModalProvider_1 = require("./ModalProvider");
Object.defineProperty(exports, "ModalProvider", { enumerable: true, get: function () { return __importDefault(ModalProvider_1).default; } });
exports.default = {
    show: (content, options) => {
        eventManager_1.default.emit(Event.Show, content, options);
    },
    hide: () => {
        eventManager_1.default.emit(Event.Hide);
    },
};
